module.exports = __webpack_public_path__ + "img/truck.c093f47f.png";